export default "__VITE_PUBLIC_ASSET__20d867ef__"